export const MADS_CODE_PREFIXES = ['MADS', 'MMTG'] as const
export type MadsCodePrefix = (typeof MADS_CODE_PREFIXES)[number]

export function splitMadsCode(value: string): { prefix: MadsCodePrefix; number: string } | null {
  const match = /^(MADS|MMTG)([0-9]+)$/.exec(value)
  if (match === null) return null
  return { prefix: match[1] as MadsCodePrefix, number: match[2]! }
}

/**
 * Existing asset labels share a numeric sequence across MADS and MMTG.
 * Free entry also allows bare numbers, hyphenated and spaced prefixes;
 * count those without rewriting the stored label (issue #74).
 */
export function nextMadsCode(codes: Array<string | null>): string {
  let maximum = 0n
  for (const code of codes) {
    const match = /^(?:(?:MADS|MMTG)[\s\-–—]*)?([0-9]+)$/i.exec((code ?? '').trim())
    const suffix = match?.[1]
    if (suffix === undefined) continue
    const number = BigInt(suffix)
    if (number > maximum) maximum = number
  }
  return `MADS${String(maximum + 1n).padStart(3, '0')}`
}
